export default "__VITE_ASSET__1eca8e20__"